import {useState, useEffect} from "react"

import {wrappedGet} from "../utilities/AxiosHelper"

export const ValueFromApiRow = ({num = -1, stmt, value, apiPath = ""}) => {
    const [apiValue, setApiValue] = useState("")
    useEffect(() => {
        if (apiPath === "") return
        let cancelled = false
        wrappedGet(apiPath)
            .then((response) => {
                if (cancelled) return
                const results = response.data.results ?? []
                const item = results.find((f) => f.id === Number.parseInt(value))
                setApiValue(item?.name ?? "Unknown")
            })
            .finally(() => {
                cancelled = true
            })
        return () => {
            cancelled = true
        }
    }, [apiPath])

    return (
        <div className="d-flex flex-row align-items-center fs-5 gap-4">
            <div className="flex-grow-1">
                <div className="d-flex ">
                    {num !== -1 && (
                        <div className="d-flex flex-column">
                            <div className="symbol symbol-30px me-4">
                                <div className="symbol-label fs-5 fw-semibold bg-primary text-inverse-danger">
                                    {num}
                                </div>
                            </div>
                        </div>
                    )}
                    <span className="d-flex flex-column pt-1">
                        <div className="d-flex flex-row fw-bold">{stmt}</div>
                        <div className="d-flex flex-row mt-2">{apiValue}</div>
                    </span>
                </div>
            </div>
        </div>
    )
}

export default ValueFromApiRow
